export const GB_FEATURES = {
  EXP_DESKTOP_PUPPY_CARD: 'exp_desktop_puppy_card',
  EXP_PUPPY_PAGE: 'exp_puppy_page',
  EXP_SEARCH_INFINITE_SCROLL_V2: 'exp_search_infinite_scroll_v2',
  EXP_PUPPY_CARD_V2: 'exp_puppy_card_v2',
  EXP_NEARBY_BREEDERS_MODULE: 'exp_nearby_breeders_module'
};
